import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import WorkRelatedDiseasesPieChart from '../common/charts/WorkRelatedDiseasesChart';
import WorkRelatedDiseasesLineChart from '../common/charts/WorkRelatedDiseasesLineChart';
import PrevalenceOfDiseasesChart from '../common/charts/PrevalenceOfDiseasesChart';
import Methodology from '../common/Methodology';

import { workRelatedDiseasesTab } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

import { getDiseasesGroupsCountries } from '../../api';

const WorkRelatedDiseases = props => {    

    const currentPath = '/accidents-diseases-well-being/work-related-diseases/';

    // Get global state for the selects
    const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
    const [countryLocked, setCountryLocked] = useState(lockedCountry);
    const [secondLevelTabs, setSecondLevelTabs] = useState([]);
    const [showSecondLevel, setShowSecondLevel] = useState(false);
    const [thirdLevelTabs, setThirdLevelTabs] = useState([]);
    const [showThirdLevel, setShowThirdLevel] = useState(false);
    const [selectedTab, setSelectedTab] = useState(undefined);
    const [secondLevelSelectedTab, setSecondLevelSelectedTab] = useState(undefined);
    const [thirdLevelSelectedTab, setThirdLevelSelectedTab] = useState(undefined);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const [chartDimension, setChartDimension] = useState(window.innerWidth > 768 ? 'column' : 'bar');
    const [dataset, setDataset] = useState(props.dataset);
    const [diseasesGroupCountries, setDiseasesGroupCountries] = useState([]);
    const [diseasesSource, setDiseasesSource] = useState({
        label: '',
        value: ''
    });
    const [loaded, setLoaded] = useState(false);
    
    // Hook for the dispatchs
    const dispatch = useDispatch();

    useEffect(() => {

        let selected = '', secondSelected = '', thirdSelected,
        secondLevel = '', thirdLevel = '', diseaseSourceLabel = '',
        diseaseSourceValue = '';
    
        selected = workRelatedDiseasesTab.find((tab) => tab.url == props.dataset);

        // If the current tab has sub-tabs, set the selected one
        if (selected.subTabs != undefined)
        {
            secondLevel = selected.subTabs;
            secondSelected = secondLevel.find((tab) => tab.url == props.indicator);
        }

        if (secondSelected.subTabs != undefined)
        {
            thirdLevel = secondSelected.subTabs;
            if (props.illness != undefined)
            {
                thirdSelected = thirdLevel.find((tab) => tab.url == props.illness);
            }
            else
            {
                thirdSelected = thirdLevel[0];
            }
        }

        if(secondSelected.url != 'disease-groups-per-country' && thirdSelected){
            thirdSelected = secondSelected.subTabs[0];
            diseaseSourceValue = thirdSelected.chartType[0].type;
        }else{
            diseaseSourceValue = secondSelected.chartType[0].type;
        }

        diseaseSourceLabel = diseaseSourceValue.toUpperCase();

        setSecondLevelTabs(secondLevel);
        setShowSecondLevel(secondLevel == '' ? false : true);
        setThirdLevelTabs(thirdLevel);
        setShowThirdLevel(thirdLevel == '' ? false : true);
        setSelectedTab(selected);
        setSecondLevelSelectedTab(secondSelected);
        setThirdLevelSelectedTab(thirdSelected);

        setDiseasesSource({
            label: diseaseSourceLabel,
            value: diseaseSourceValue
        })

        // Update the title of the page
		document.title = props.literals.L20026 + " - " + props.literals.L22020 + " - " + props.literals.L363;
        window.addEventListener('resize', updateDimension);
        setLoaded(true);
    }, [])

    useEffect(() => {
        if (secondLevelSelectedTab != undefined)
        {
            loadDiseasesGroupCountries(secondLevelSelectedTab.chartType);
        }        
    }, [diseasesSource])

    useEffect(() => {
        if (secondLevelSelectedTab && secondLevelSelectedTab.url == 'disease-groups-per-country')
        {
            loadDiseasesGroupCountries(secondLevelSelectedTab.chartType);
        }
    }, [secondLevelSelectedTab])

    const loadDiseasesGroupCountries = (chartType) => {
        let chart = [];

        if (secondLevelSelectedTab.url == 'disease-groups-per-country')
        {
            if(diseasesSource){
                chart = chartType.find((chart) => chart.type == diseasesSource.value);
            }else{
                chart = chartType[0];
            }        
    
            getDiseasesGroupsCountries(chart.chart)
            .then((data) => {
                if(data){
                    setDiseasesGroupCountries(data.resultset);
                }
            })
        }
    }

    const handleSearch = (callbackCountry1) => {
        if (selectedByUser) {
            setCountryLocked(callbackCountry1);
        } else {
            dispatch(setCountry1(callbackCountry1));
        }
	}

	const handleSearch2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
	}

	const handleSearch3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
	}

    //This function will be called when changing between WHO-ILO and ICOH
    const callbackSelectedTab = (callback) => {
        setDataset(callback);
        setShowSecondLevel(true);
        setShowThirdLevel(true);

        let newSelectedTab = workRelatedDiseasesTab.find((tab) => tab.url == callback);
        setSelectedTab(newSelectedTab);
        setSecondLevelTabs(newSelectedTab.subTabs);
        setSecondLevelSelectedTab(newSelectedTab.subTabs[0]);
        setThirdLevelTabs(newSelectedTab.subTabs[0].subTabs);
        setThirdLevelSelectedTab(newSelectedTab.subTabs[0].subTabs[0]);
	}

    // This function will be called when changing the indicator on the current tab
    const callbackSelectedIndicator = (callback) => {
        if(callback != 'disease-groups-per-country'){
            setShowThirdLevel(true);

            let newSelectedTab = secondLevelTabs.find((tab) => tab.url == callback);
            setSecondLevelSelectedTab(newSelectedTab);
            setThirdLevelTabs(newSelectedTab.subTabs);
            setThirdLevelSelectedTab(newSelectedTab.subTabs[0]);
        }
        else
        {
            setShowThirdLevel(false);

            let newSelectedTab = secondLevelTabs.find((tab) => tab.url == callback);
            setSecondLevelSelectedTab(newSelectedTab);
        }
	}

    // This function will be called when changing the split on the current indicator
    const callbackSelectedSplit = (callback) => {
        const newSelectedTab = thirdLevelTabs.find((tab) => tab.url == callback);
        setThirdLevelSelectedTab(newSelectedTab);
    }

    const callbackDiseasesSource = (callback) => {
        setDiseasesSource({
            label: callback.toUpperCase(),
            value: callback
        });
    }

    const onChangeSource = (e) => {
        setDiseasesSource({
            label: e.label,
            value: e.value
        })
    }

    const updateDimension = () => {
        if(window.innerWidth > 768){
            setChartDimension('column');
		}else{
            setChartDimension('bar');
		}
    }

    const getMethodologyIndicator = (pChartType, pDataset) => {
        for (let i = 0; i < pChartType.length; i++)
        {
            if (pDataset == pChartType[i].type || pChartType.length == 1)
            {
                return pChartType[i].chartIndicator;
            }
        }
    }

    if (!loaded)
    {
        return null;
    }

    let submenu = '';
    let thirdSubMenu = '';
    let sourceDiv = '';
    let methodologyIndicator = "";
    
    if (showSecondLevel)
    {
        submenu = <div className='second--submenu'>
                    <div className="line background-main-light" />
                    <SubMenuTabs 
                        literals={ props.literals }
                        selectedTab={ secondLevelSelectedTab.url }
                        callbackSelectedTab={ callbackSelectedIndicator }
                        locationPath={ `${currentPath}${dataset}/` }
                        subMenuTabs={ secondLevelTabs }
                        selectedSurvey = { dataset }
                    />
                </div>
        
        // If the current subtab has another menu inside, it will display it in a third row
        if(showThirdLevel){
            methodologyIndicator = getMethodologyIndicator(thirdLevelSelectedTab.chartType, diseasesSource.value);
            thirdSubMenu = <div className='third--submenu'>
                    <div className="line background-main-light" />
                    <SubMenuTabs 
                        literals={ props.literals }
                        selectedTab={ thirdLevelSelectedTab.url }
                        callbackSelectedTab={ callbackSelectedSplit }
                        locationPath={ `${currentPath}${dataset}/${secondLevelSelectedTab.url}/` }
                        subMenuTabs={ thirdLevelTabs }
                        selectedSurvey = { dataset }
                    />
                </div>
        } 
        else 
        {
            let selectOptions = secondLevelSelectedTab.chartType;
            methodologyIndicator = getMethodologyIndicator(secondLevelSelectedTab.chartType, diseasesSource.value);

            sourceDiv = <div className='source--dataset--block select--dataset--chart'>
                <Select
                    onChange={(e) => onChangeSource(e)}
                    value={ diseasesSource }
                    className="select-component"
                    options={ selectOptions.map(chart=>( { label: chart.type.toUpperCase(), value: chart.type } ) ) }
                />
            </div>
        }
    }

    let showSelect = true;
    if (thirdLevelSelectedTab != null && thirdLevelSelectedTab.chartType.length <= 1)
    {
        showSelect = false;
    }

    let chartFooter;
    if (secondLevelSelectedTab.url == 'prevalence-of-diseases' || secondLevelSelectedTab.url == 'development-in-eu-countries')
    {
        let chart = thirdLevelSelectedTab.chartType.find((chart) => chart.type == diseasesSource.value);
        if (chart == null && thirdLevelSelectedTab.chartType.length == 1)
        {
            chart = thirdLevelSelectedTab.chartType[0];
        }
        chartFooter = chart.legend;
    }

    const selectCountry1 = selectedByUser ? countryLocked : selectCountry;

    return (
        <div className="work-related-diseases">
            <AdviceSection literals={ props.literals } section={ ["accidents-diseases-well-being","work-related-diseases"] } 
                methodologyData={ {section: 'accidents-diseases-well-being', subsection: 'Work-related diseases', indicator: 419} } />

            <div className='top--submenu'>
                <SubMenuTabs 
                    literals={ props.literals }
                    selectedTab={ selectedTab.url }
                    callbackSelectedTab={ callbackSelectedTab }
                    locationPath={ currentPath }
                    subMenuTabs={ workRelatedDiseasesTab }
                    selectedSurvey = { dataset }
                />
            </div>

            { submenu }

            { thirdSubMenu }

            <div className="line background-main-light" />

            <div className='container section--page no--padding card--grid xxs-w1 xs-w1 w1 center-text'>
                {
                    secondLevelSelectedTab.url == 'prevalence-of-diseases' && (
                        <React.Fragment>
                            <div className={`card--block--chart ${showSelect == false ? '': 'short-margin'}` }>
                                <div className='chart--block'>
                                    <div className='chart-container'>
                                        <PrevalenceOfDiseasesChart
                                            literals={ props.literals }
                                            showSelect={ showSelect }
                                            chartType={ thirdLevelSelectedTab.chartType }
                                            colors={ ['#f6a300', '#cbe2e3'] }
                                            type={ chartDimension }
                                            callbackDiseasesSource={ callbackDiseasesSource }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="chart-legend">
                                { ReactHtmlParser(props.literals[`L${ chartFooter }`]) }
                            </div>
                        </React.Fragment>
                    )
                }
                    
                {
                    secondLevelSelectedTab.url == 'disease-groups-per-country' && (
                        <div className='pie--chart--card'>
                            {/* SELECT FOR DALY Y DEATHS */}
                            <div className='chart--filters--block'>
                                { sourceDiv }
                            </div>
                            <div className='section--sticky--chart center-text'>
                                <div className='main-chart'>
                                    <WorkRelatedDiseasesPieChart 
                                        //title="Main work related illnesses and DALY (Years of life lost and lived with disability) per 100,000 workers"
                                        width="450"
                                        height="350"
                                        country={ {code: "EU27_2020", name: props.literals.L822} }
                                        chartType={ secondLevelSelectedTab.chartType }
                                        diseasesSource={ diseasesSource }
                                        legend={ true }
                                        legendTitle={ diseasesSource.label }
                                    />
                                    <WorkRelatedDiseasesPieChart 
                                        //title="Main work related illnesses and DALY (Years of life lost and lived with disability) per 100,000 workers"
                                        width="450"
                                        height="350"
                                        country={ {code: "GLOBAL", name: props.literals.L263} }
                                        chartType={ secondLevelSelectedTab.chartType }
                                        diseasesSource={ diseasesSource }
                                        legend={ true }
                                        legendTitle={ diseasesSource.label }
                                    />
                                </div>
                            </div>
                            <div className='page-break'></div>
                            <div className='pie--chart--section'>
                                <div className='pie--chart--subsection'>
                                    {
                                        diseasesGroupCountries.map((country) => {
                                            return (
                                                <div key={country.code} className="pie-chart-each">
                                                    <WorkRelatedDiseasesPieChart 
                                                        title=""
                                                        width="320"
                                                        height="320"
                                                        country={ country }
                                                        chartType={ secondLevelSelectedTab.chartType }
                                                        diseasesSource={ diseasesSource }
                                                        legend={ false }
                                                    />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    secondLevelSelectedTab.url == 'development-in-eu-countries' && (
                        <div>
                            <SelectEconomic 
                                handleSearch={ handleSearch } 
                                handleSearch2={ handleSearch2 } 
                                handleSearch3={ handleSearch3 }
                                charts={ ['20130'] }
                                indicator={ '419' }
                                literals={ props.literals }
                                selectedCountry1={ selectCountry1 }
                                selectedCountry2={ selectCountry2 }
                                selectedCountry3={ selectCountry3 }
                            />
                            <div className="line background-main-light" />
                            <div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
                                <div className={`card--block--chart ${showSelect == false ? '': 'short-margin'}` }>
                                    <div className="chart--block">
                                        <WorkRelatedDiseasesLineChart
                                            chartType={ thirdLevelSelectedTab.chartType }
                                            country1={ selectCountry1 }
                                            country2={ selectCountry2 }
                                            country3={ selectCountry3 }
                                            title={ props.literals.L20392 }
                                            colors={ ['#f6a400','#529FA2','#7b7b7d','#ffe300','#449fa2','#f3c564','#16983e','#003399'] }
                                            literals={ props.literals }
                                            callbackDiseasesSource={ callbackDiseasesSource }
                                        />
                                    </div>
                                </div>
                                <div className="chart-legend">
                                    { ReactHtmlParser(props.literals[`L${ chartFooter }`]) }
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            <Methodology literals={ props.literals } section={'Work-related diseases'} indicator={ methodologyIndicator } /> 
        </div>
    )
}

WorkRelatedDiseases.displayName = 'WorkRelatedDiseases';
export default WorkRelatedDiseases;